import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { mobileTasksRoutes } from './mobile-tasks.routing'
import { MobileTasksComponent } from './mobile-tasks.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { ActiveLayerMapModule } from '@components/active-layer-map/active-layer-map.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [MobileTasksComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(mobileTasksRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SweetAlert2Module.forRoot(),
    HttpClientModule,
    SharedModule,
    ActiveLayerMapModule,
    BreadcrumbsModule,
  ],
  exports: [MobileTasksComponent],
})
export class MobileTasksModule {}
